/* tslint:disable */
/* eslint-disable */
/**
 * Stacks Blockchain API
 * Welcome to the API reference overview for the [Stacks Blockchain API](https://docs.hiro.so/stacks-blockchain-api).  [Download Postman collection](https://hirosystems.github.io/stacks-blockchain-api/collection.json) 
 *
 * The version of the OpenAPI document: STACKS_API_VERSION
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MempoolTransactionStatsResponseTxSimpleFeeAveragesTokenTransfer,
    MempoolTransactionStatsResponseTxSimpleFeeAveragesTokenTransferFromJSON,
    MempoolTransactionStatsResponseTxSimpleFeeAveragesTokenTransferFromJSONTyped,
    MempoolTransactionStatsResponseTxSimpleFeeAveragesTokenTransferToJSON,
} from './';

/**
 * The average time (in blocks) that transactions have lived in the mempool. The start block height is simply the current chain-tip of when the attached Stacks node receives the transaction. This timing can be different across Stacks nodes / API instances due to propagation timing differences in the p2p network.
 * @export
 * @interface MempoolTransactionStatsResponseTxAges
 */
export interface MempoolTransactionStatsResponseTxAges {
    /**
     * 
     * @type {MempoolTransactionStatsResponseTxSimpleFeeAveragesTokenTransfer}
     * @memberof MempoolTransactionStatsResponseTxAges
     */
    token_transfer: MempoolTransactionStatsResponseTxSimpleFeeAveragesTokenTransfer;
    /**
     * 
     * @type {MempoolTransactionStatsResponseTxSimpleFeeAveragesTokenTransfer}
     * @memberof MempoolTransactionStatsResponseTxAges
     */
    smart_contract: MempoolTransactionStatsResponseTxSimpleFeeAveragesTokenTransfer;
    /**
     * 
     * @type {MempoolTransactionStatsResponseTxSimpleFeeAveragesTokenTransfer}
     * @memberof MempoolTransactionStatsResponseTxAges
     */
    contract_call: MempoolTransactionStatsResponseTxSimpleFeeAveragesTokenTransfer;
    /**
     * 
     * @type {MempoolTransactionStatsResponseTxSimpleFeeAveragesTokenTransfer}
     * @memberof MempoolTransactionStatsResponseTxAges
     */
    poison_microblock: MempoolTransactionStatsResponseTxSimpleFeeAveragesTokenTransfer;
}

export function MempoolTransactionStatsResponseTxAgesFromJSON(json: any): MempoolTransactionStatsResponseTxAges {
    return MempoolTransactionStatsResponseTxAgesFromJSONTyped(json, false);
}

export function MempoolTransactionStatsResponseTxAgesFromJSONTyped(json: any, ignoreDiscriminator: boolean): MempoolTransactionStatsResponseTxAges {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token_transfer': MempoolTransactionStatsResponseTxSimpleFeeAveragesTokenTransferFromJSON(json['token_transfer']),
        'smart_contract': MempoolTransactionStatsResponseTxSimpleFeeAveragesTokenTransferFromJSON(json['smart_contract']),
        'contract_call': MempoolTransactionStatsResponseTxSimpleFeeAveragesTokenTransferFromJSON(json['contract_call']),
        'poison_microblock': MempoolTransactionStatsResponseTxSimpleFeeAveragesTokenTransferFromJSON(json['poison_microblock']),
    };
}

export function MempoolTransactionStatsResponseTxAgesToJSON(value?: MempoolTransactionStatsResponseTxAges | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token_transfer': MempoolTransactionStatsResponseTxSimpleFeeAveragesTokenTransferToJSON(value.token_transfer),
        'smart_contract': MempoolTransactionStatsResponseTxSimpleFeeAveragesTokenTransferToJSON(value.smart_contract),
        'contract_call': MempoolTransactionStatsResponseTxSimpleFeeAveragesTokenTransferToJSON(value.contract_call),
        'poison_microblock': MempoolTransactionStatsResponseTxSimpleFeeAveragesTokenTransferToJSON(value.poison_microblock),
    };
}

